import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { friendlyDateTimeShort, friendlyDateTimeWithDayShort } from '@app/_helpers';
import { ActivityListItem, Organization } from '@app/_store';
import { RouterLink } from '@angular/router';
import { NgIf, NgClass, DatePipe } from '@angular/common';

@Component({
  selector: 'app-activity-item-card',
  templateUrl: './activity-item-card.component.html',
  styleUrl: './activity-item-card.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, NgIf, NgClass, DatePipe],
})
export class ActivityItemCardComponent {
  @Input()
  organization: Organization;

  @Input()
  activity: ActivityListItem;

  friendlyDateTimeWithDayShort = friendlyDateTimeWithDayShort;
  friendlyDateTimeShort = friendlyDateTimeShort;

  now: Date = new Date();
}
